export function resolveDblClickAction(config: {
  dblSelect: boolean;
  hasCustomDblClick: boolean;
  dblClickEdit: boolean;
  doEdit: boolean;
}): 'none' | 'custom' | 'edit' {
  if (config.dblSelect) return 'none';
  if (config.hasCustomDblClick) return 'custom';
  if (config.dblClickEdit && config.doEdit) return 'edit';
  return 'none';
}
